export class GoogleHelper {
    /**
     * Get street with street number from autocomplete extended details
     */
    static getStreetFromAutocompleteDetails(
        details: google.maps.places.PlaceResult,
    ): string | undefined {
        // Try to get full street address first
        const neededComponent = GoogleHelper._getComponentByType(
            details,
            "street_address",
        )

        if (neededComponent) {
            return neededComponent.long_name
        }

        // Fallback to street number and route
        const numberComponent = GoogleHelper._getComponentByType(
            details,
            "street_number",
        )

        const routeComponent = GoogleHelper._getComponentByType(
            details,
            "route",
        )

        return numberComponent || routeComponent
            ? `${numberComponent ? `${numberComponent.long_name} ` : ""}${
                  routeComponent ? routeComponent.long_name : ""
              }`
            : undefined
    }

    /**
     * Get city from autocomplete extended details
     */
    static getCityFromAutocompleteDetails(
        details: google.maps.places.PlaceResult,
    ): string | undefined {
        const neededComponent = GoogleHelper._getComponentByType(
            details,
            "locality",
        )

        return neededComponent ? neededComponent.short_name : undefined
    }

    /**
     * Get state from autocomplete extended details
     */
    static getStateFromAutocompleteDetails(
        details: google.maps.places.PlaceResult,
    ): string | undefined {
        const neededComponent = GoogleHelper._getComponentByType(
            details,
            "administrative_area_level_1",
        )

        return neededComponent ? neededComponent.short_name : undefined
    }

    /**
     * Get zip from autocomplete extended details
     */
    static getZipFromAutocompleteDetails(
        details: google.maps.places.PlaceResult,
    ): string | undefined {
        const neededComponent = GoogleHelper._getComponentByType(
            details,
            "postal_code",
        )

        return neededComponent ? neededComponent.short_name : undefined
    }

    /**
     * Get specific component by type
     * Types and meaning can be found here: // https://developers.google.com/maps/documentation/geocoding/overview#Types
     */
    static _getComponentByType(
        details: google.maps.places.PlaceResult,
        type: string,
    ): google.maps.GeocoderAddressComponent | undefined {
        if (!details.address_components) {
            return undefined
        }

        return details.address_components.find(
            (item: google.maps.GeocoderAddressComponent) =>
                !!~item.types.indexOf(type),
        )
    }
}
